/* eslint-disable react/no-danger */
/* eslint-disable react/forbid-prop-types */
import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { FiChevronDown, FiCoffee } from 'react-icons/fi';
import PackageImage from '../common/PackageImage';
import { MEALS, packageImageUrl } from '../../utils/packageUtils';
import { sanitizeHtml } from '../../utils/safeHtml';

/** Day-by-day plan. Day 1 starts open; "Expand all" opens the rest. */
function PackageItinerary({ days }) {
  const [open, setOpen] = useState(
    () => new Set(days.length ? [days[0].dayNumber] : []),
  );
  const html = useMemo(
    () =>
      Object.fromEntries(
        days.map((d) => [d.dayNumber, sanitizeHtml(d.description)]),
      ),
    [days],
  );
  const allOpen = days.length > 0 && days.every((d) => open.has(d.dayNumber));

  const toggle = (n) =>
    setOpen((prev) => {
      const next = new Set(prev);
      if (next.has(n)) next.delete(n);
      else next.add(n);
      return next;
    });

  return (
    <div className="pkg-itinerary">
      <button
        type="button"
        className="pkg-itinerary__all"
        onClick={() =>
          setOpen(allOpen ? new Set() : new Set(days.map((d) => d.dayNumber)))
        }
      >
        {allOpen ? 'Collapse all' : 'Expand all'}
      </button>
      <ol className="pkg-itinerary__list">
        {days.map((d) => {
          const isOpen = open.has(d.dayNumber);
          const meals = MEALS.filter((m) => Number(d[m.key]) > 0);
          const images = (Array.isArray(d.images) ? d.images : [])
            .map(packageImageUrl)
            .filter(Boolean)
            .slice(0, 3);
          return (
            <li
              key={d.dayNumber}
              className={`pkg-day ${isOpen ? 'pkg-day--open' : ''}`}
            >
              <button
                type="button"
                className="pkg-day__head"
                aria-expanded={isOpen}
                onClick={() => toggle(d.dayNumber)}
              >
                <span className="pkg-day__num">Day {d.dayNumber}</span>
                <span className="pkg-day__title">{d.title || ''}</span>
                <FiChevronDown className="pkg-day__caret" />
              </button>
              {isOpen && (
                <div className="pkg-day__body">
                  {images.length > 0 && (
                    <div className="pkg-day__images">
                      {images.map((src) => (
                        <PackageImage key={src} src={src} />
                      ))}
                    </div>
                  )}
                  {html[d.dayNumber] && (
                    <div
                      className="pkg-html"
                      dangerouslySetInnerHTML={{ __html: html[d.dayNumber] }}
                    />
                  )}
                  {meals.length > 0 && (
                    <p className="pkg-day__meals">
                      <FiCoffee />
                      {meals.map((m) => (
                        <span key={m.key} className="pkg-chip">
                          {m.label}
                        </span>
                      ))}
                    </p>
                  )}
                </div>
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
}

PackageItinerary.propTypes = {
  days: PropTypes.array.isRequired,
};

export default PackageItinerary;
